import React from 'react';
import {
  Box,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Autocomplete,
} from '@mui/material';
import { Button, Checkbox, Radio, Combo } from '../../Components/MUIs';
import { KakaoPost } from '../../Components/Kakaos';
import { ArrowForwardIos as RightIcon } from '@mui/icons-material';

const steps = ['약관', '유형 선택', '정보 입력', '추가 정보 입력'];

function SignUp(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [dialog1, setDialog1] = React.useState(false);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const HandleNext = (_current) => {
    let newSkipped = skipped;

    if (_current === 2) {
      if (!props.SignUpIndex2Validation()) {
        return false;
      }
    } else if (_current === 3) {
      if (!props.SignUpIndex3Validation()) {
        return false;
      } else {
        props.SaveLogic2();
      }
    }

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const HandleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const HandleReset = () => {
    setActiveStep(0);
  };

  const RecievePosts = (_data) => {
    if (!_data.road_address) {
      return false;
    } else {
      props.setSignUpInputs({
        ...props.signUpInputs,
        userPost: _data.road_address.zone_no,
        userAddress1: _data.road_address.address_name,
      });
    }
  };

  const ReturnAuthChecked = () => {
    switch (props.signUpInputs.userAuth) {
      case 'SITE_MANAGER':
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Combo
              sx={{ mr: 1 }}
              fullWidth
              name="지역"
              items={props.regions}
              value={props.signUpInputs.authRegion}
              onChange={(e) => {
                props.SearchLogic4(e);
                props.setSignUpInputs({
                  ...props.signUpInputs,
                  authRegion: e,
                });
              }}
            />
            <Autocomplete
              sx={{ minWidth: '280px', zIndex: 999996 }}
              fullWidth
              freeSolo
              value={props.siteManagerSite ? props.siteManagerSite : ''}
              onChange={(e, newValue) => {
                props.setSiteManagerSite(newValue);
              }}
              inputValue={
                props.siteManagerSiteInput ? props.siteManagerSiteInput : ''
              }
              onInputChange={(e, newValue) =>
                props.setSiteManagerSiteInput(newValue)
              }
              options={
                props.siteList
                  ? props.siteList.map((item) => item.name)
                  : ['데이터가 없습니다.']
              }
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
        );
      case 'HEAD_MANAGER':
        return (
          <Autocomplete
            sx={{ minWidth: '280px', zIndex: 999996 }}
            fullWidth
            freeSolo
            value={props.headManagerSite ? props.headManagerSite : ''}
            onChange={(e, newValue) => {
              props.setHeadManagerSite(newValue);
            }}
            inputValue={
              props.headManagerSiteInput ? props.headManagerSiteInput : ''
            }
            onInputChange={(e, newValue) =>
              props.setHeadManagerSiteInput(newValue)
            }
            options={
              props.custList
                ? props.custList.map((item) => item.name)
                : ['데이터가 없습니다.']
            }
            renderInput={(params) => <TextField {...params} />}
          />
        );
      case 'BUSINESS_OWNER':
      case 'VIEWER':
      case 'ADMIN':
        return (
          <Combo
            sx={{ mr: 1 }}
            fullWidth
            name="지역"
            items={props.regions}
            value={props.signUpInputs.authRegion}
            onChange={(e) => {
              props.SearchLogic4(e);
              props.setSignUpInputs({
                ...props.signUpInputs,
                authRegion: e,
              });
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 6, mb: 1 }}>
            세이프온의 안전에 오신 것을 환영합니다.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button
              variant="text"
              name="확인"
              onClick={() => props.CloseDialog()}
            />
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {activeStep === 0 ? (
            <Stack sx={{ mt: 1, mb: 1 }} spacing={1}>
              <List sx={{ width: '100%' }}>
                <ListItem
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <RightIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        serviceUsingCheck:
                          !props.signUpInputs.serviceUsingCheck,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        name=""
                        checked={props.signUpInputs.serviceUsingCheck}
                      />
                    </ListItemIcon>
                    <ListItemText primary="[필수] 서비스 이용 동의" />
                  </ListItemButton>
                </ListItem>
                <ListItem
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <RightIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        personalInformationCheck:
                          !props.signUpInputs.personalInformationCheck,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        name=""
                        checked={props.signUpInputs.personalInformationCheck}
                      />
                    </ListItemIcon>
                    <ListItemText primary="[필수] 개인정보 수집 및 이용동의" />
                  </ListItemButton>
                </ListItem>
                <ListItem
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <RightIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        locationSerciveCheck:
                          !props.signUpInputs.locationSerciveCheck,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        name=""
                        checked={props.signUpInputs.locationSerciveCheck}
                      />
                    </ListItemIcon>
                    <ListItemText primary="[필수] 위치 기반 서비스 이용동의" />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        aged14Check: !props.signUpInputs.aged14Check,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        name=""
                        checked={props.signUpInputs.aged14Check}
                      />
                    </ListItemIcon>
                    <ListItemText primary="[필수] 만 14세 이상 이용자" />
                  </ListItemButton>
                </ListItem>
                <ListItem
                  secondaryAction={
                    <IconButton edge="end" aria-label="comments">
                      <RightIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        marketingCheck: !props.signUpInputs.marketingCheck,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        name=""
                        checked={props.signUpInputs.marketingCheck}
                      />
                    </ListItemIcon>
                    <ListItemText primary="[선택] 마케팅 목적 개인정보 수집 및 이용동의" />
                  </ListItemButton>
                </ListItem>
              </List>
              <Checkbox
                name="약관 전체 동의"
                checked={props.signUpInputs.allAgreeCheck}
                onChange={(e) => {
                  if (e) {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      serviceUsingCheck: true,
                      personalInformationCheck: true,
                      locationSerciveCheck: true,
                      aged14Check: true,
                      marketingCheck: true,
                      allAgreeCheck: e,
                    });
                  } else {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      serviceUsingCheck: false,
                      personalInformationCheck: false,
                      locationSerciveCheck: false,
                      aged14Check: false,
                      marketingCheck: false,
                      allAgreeCheck: e,
                    });
                  }
                }}
              />
            </Stack>
          ) : activeStep === 1 ? (
            <Stack sx={{ mt: 4, mb: 2 }} spacing={2}>
              <Typography variant="h5">가입 유형을 선택하세요.</Typography>
              <Radio
                items={props.signUpInputs.userTypeList}
                value={props.signUpInputs.userType}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userType: e,
                  });
                }}
              />
            </Stack>
          ) : activeStep === 2 ? (
            <Stack sx={{ mt: 2, mb: 1 }} spacing={2}>
              <Stack direction="row" spacing={2}>
                <TextField
                  // sx={{ minWidth: 280 }}
                  label={
                    props.lanList.length > 0
                      ? props.lanList.filter((f) => f.lanId === 'Id')[0].lanNm
                      : '' // ID
                  }
                  value={props.signUpInputs.userId}
                  onChange={(e) => {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      userId: e.target.value,
                    });
                  }}
                  fullWidth
                />
                <Button
                  sx={{ minWidth: 100 }}
                  name="중복확인"
                  onClick={() => props.CheckUserId()}
                />
              </Stack>
              <Typography
                textAlign="right"
                color={
                  props.signUpInputs.userId &&
                  props.signUpInputs.idDuplicationCheck
                    ? 'green'
                    : 'red'
                }
              >
                {props.signUpInputs.userId &&
                props.signUpInputs.idDuplicationCheck
                  ? '사용 가능한 ID입니다.'
                  : props.signUpInputs.idDuplicationCheck === ''
                    ? null
                    : '사용 불가능한 ID입니다.'}
              </Typography>
              <TextField
                sx={{ minWidth: 280 }}
                label={
                  props.lanList.length > 0
                    ? props.lanList.filter((f) => f.lanId === 'Name')[0].lanNm
                    : '' // 이름
                }
                value={props.signUpInputs.userNm}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userNm: e.target.value,
                  });
                }}
              />
              <TextField
                sx={{ minWidth: 280 }}
                type="password"
                label={
                  props.lanList.length > 0
                    ? props.lanList.filter((f) => f.lanId === 'Password')[0]
                        .lanNm
                    : '' // Password
                }
                value={props.signUpInputs.userPw}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userPw: e.target.value,
                  });
                }}
              />
              <TextField
                sx={{ minWidth: 280 }}
                type="password"
                label={
                  props.lanList.length > 0
                    ? props.lanList.filter(
                        (f) => f.lanId === 'PasswordConfirm'
                      )[0].lanNm
                    : '' // Password 확인
                }
                value={props.signUpInputs.userPwConfirm}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userPwConfirm: e.target.value,
                  });
                }}
              />
              <Typography variant="caption">
                {`(8자리 이상, 대문자, 숫자, 특수문자가 포함되어야합니다.)`}
              </Typography>
              <Typography textAlign="right" color="red">
                {(props.signUpInputs.userPw !== '' ||
                  props.signUpInputs.userPwConfirm !== '') &&
                props.signUpInputs.userPw !== props.signUpInputs.userPwConfirm
                  ? '비밀번호가 다릅니다.'
                  : null}
              </Typography>
              <TextField
                sx={{ minWidth: 280 }}
                label={
                  props.lanList.length > 0
                    ? props.lanList.filter((f) => f.lanId === 'Tel')[0].lanNm
                    : '' // 전화번호
                }
                value={props.signUpInputs.userTel}
                type="tel"
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userTel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
              />
              <Stack direction="row" spacing={1}>
                <TextField
                  fullWidth
                  label="E-Mail"
                  value={props.signUpInputs.userEmail1}
                  type="email"
                  onChange={(e) => {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      userEmail1: e.target.value,
                    });
                  }}
                />
                <TextField
                  fullWidth
                  label=""
                  value={props.signUpInputs.userEmail2}
                  type="email"
                  onChange={(e) => {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      userEmail2: e.target.value,
                    });
                  }}
                  disabled={
                    props.signUpInputs.emailCombo === 'jigjub' ? false : true
                  }
                />
                <Combo
                  fullWidth
                  items={[
                    { value: 'jigjub', name: '직접입력' },
                    { value: 'google.com', name: 'google' },
                    { value: 'naver.com', name: 'naver' },
                    { value: 'daum.com', name: 'daum' },
                    { value: 'kakao.com', name: 'kakao' },
                    { value: 'nate.com', name: 'nate' },
                  ]}
                  value={props.signUpInputs.emailCombo}
                  onChange={(e) => {
                    props.setSignUpInputs({
                      ...props.signUpInputs,
                      emailCombo: e,
                      userEmail2: e === 'jigjub' ? '' : e,
                    });
                  }}
                />
              </Stack>
            </Stack>
          ) : (
            <Stack sx={{ mt: 2, mb: 1 }} spacing={2}>
              <TextField
                sx={{ minWidth: 280 }}
                label={
                  props.lanList.length > 0
                    ? props.lanList.filter((f) => f.lanId === 'EmTel')[0].lanNm
                    : '' // 비상연락처
                }
                value={props.signUpInputs.userEmTel}
                type="tel"
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userEmTel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
              />
              <Stack direction="row" spacing={2}>
                <TextField
                  label="우편번호"
                  value={props.signUpInputs.userPost}
                  fullWidth
                  disabled
                />
                <Button
                  sx={{ minWidth: 100 }}
                  name="주소검색"
                  onClick={() => setDialog1(true)}
                />
              </Stack>
              <TextField
                sx={{ minWidth: 280 }}
                label="주소"
                value={props.signUpInputs.userAddress1}
                disabled
              />
              <TextField
                sx={{ minWidth: 280 }}
                label="상세 주소"
                value={props.signUpInputs.userAddress2}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userAddress2: e.target.value,
                  });
                }}
                disabled={props.signUpInputs.userAddress1 ? false : true}
              />
              <Combo
                name="혈액형"
                items={props.signUpInputs.bloodList}
                value={props.signUpInputs.userBlood}
                onChange={(e) => {
                  props.setSignUpInputs({
                    ...props.signUpInputs,
                    userBlood: e,
                  });
                }}
              />
              {props.signUpInputs.userType === 'EMPLOYEE' ? (
                <Stack sx={{ mt: 4, mb: 2 }} spacing={2}>
                  <Combo
                    name="국적"
                    items={props.signUpInputs.nationList}
                    value={props.signUpInputs.userNation}
                    onChange={(e) => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        userNation: e,
                      });
                    }}
                  />
                  <TextField
                    sx={{ minWidth: 280 }}
                    label="VISA"
                    value={props.signUpInputs.userVisa}
                    onChange={(e) => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        userVisa: e.target.value,
                      });
                    }}
                    disabled={
                      props.signUpInputs.userNation === 'KR' ? true : false
                    }
                  />
                </Stack>
              ) : (
                <Stack sx={{ mt: 4, mb: 2 }} spacing={2}>
                  <Combo
                    name="요청 권한 선택"
                    items={props.authGroups}
                    value={props.signUpInputs.userAuth}
                    onChange={(e) => {
                      props.setSignUpInputs({
                        ...props.signUpInputs,
                        userAuth: e,
                      });

                      if (e === 'HEAD_MANAGER') {
                        props.SearchLogic5();
                      }
                    }}
                  />
                  {ReturnAuthChecked()}
                </Stack>
              )}
            </Stack>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
              sx={{ mr: 1 }}
              color="inherit"
              name="Back"
              variant="text"
              disabled={activeStep === 0}
              onClick={HandleBack}
            />
            <Box sx={{ flex: '1 1 auto' }} />
            <Button
              variant="text"
              name={activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              onClick={() => HandleNext(activeStep)}
              disabled={
                props.signUpInputs.serviceUsingCheck &&
                props.signUpInputs.personalInformationCheck &&
                props.signUpInputs.locationSerciveCheck &&
                props.signUpInputs.aged14Check
                  ? false
                  : true
              }
            />
          </Box>
        </React.Fragment>
      )}
      <KakaoPost
        open={dialog1}
        onClose={() => setDialog1(false)}
        title="주소 검색"
        ReceivePost={(_data) => RecievePosts(_data)}
      />
    </Box>
  );
}

export default SignUp;
